# Phase 3: Ad selection

SEEK hirers must be shown all available SEEK ad products with pricing when they create or update an ad in your software.

Available ad products and pricing are different for every SEEK hirer.
As a result, partners are no longer able to hardcode SEEK ad products.

SEEK offers two solutions to enable partners to show ad products with pricing:

import { Recommended } from '../../../components/Recommended/Recommended';

1. Ad Selection Panel <Recommended />

   SEEK offers a themeable Ad Selection Panel that can be embedded into your posting flow.

2. GraphQL

   Available ad products can be programmatically retrieved by your software when [posting] or [updating] a job ad.
   This allows partners to build custom user interfaces for ad product selection.

import { Alert, Text } from 'braid-design-system';

<Alert tone="promote">
  <Text>
    SEEK strongly recommends using the Ad Selection Panel for your integration.
    It will significantly reduce development time, ongoing maintenance, as well
    as provide an up-to-date user experience for SEEK hirers. Implementation of
    a custom Ad Selection Panel will require you to support and maintain various
    ad type requirements such as what ad types can be upgraded, price and price
    variation visibility, etc.
  </Text>
</Alert>

For more information on implementing ad selection, see the [Ad Selection documentation].

[ad selection documentation]: /use-cases/job-posting/ad-selection
[posting]: /use-cases/job-posting/managing-job-ads/posting-a-job-ad
[updating]: /use-cases/job-posting/managing-job-ads/updating-a-job-ad

## Exit criteria

The following criteria need to be met before moving to the next phase:

| Criteria                    | Description                                                                                                                           |
| --------------------------- | ------------------------------------------------------------------------------------------------------------------------------------- |
| Ad selection built          | SEEK hirers can select from all available SEEK ad products and see product pricing when creating or editing a job ad in your software |
| User experience signed off  | SEEK has signed off on your ad selection user experience                                                                              |
| Job ad posted successfully  | Hirer can successfully post a SEEK job ad with their chosen SEEK ad product                                                           |
| Job ad updated successfully | Hirer can successfully update a SEEK job ad with their chosen SEEK ad product                                                         |
